mutation SetContractPaymentStatus(
  $id: ID!
  $status: String!
  $paidAt: DateTime
  $note: String
) {
  setContractPaymentStatus(
    id: $id
    status: $status
    paidAt: $paidAt
    note: $note
  ) {
    id
    status
    expired
    paidAt
    note
  }
}
